module.exports = __webpack_public_path__ + "static/media/image_21.3b857582.png";